import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import EXTERNAL_URLS from 'constants/externalUrls';
import { useTranslation } from 'react-i18next';

const MailNotificationsBreadcrumbAdditionalContent = () => {
  const { t } = useTranslation();

  return (
    <InfoWithTooltip
      title={t('common.mainMenu.mailNotificationsInfo')}
      link={EXTERNAL_URLS.mailNotifications}
      size="s"
    />
  );
};

export default MailNotificationsBreadcrumbAdditionalContent;
